/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend/src/app/modules/catalog-cloud/resolvers/fascicle.resolver copy.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend
 * Created Date: Monday, December 16th 2024, 3:47:42 pm
 * Author: Tomás
 * -----
 * Last Modified:  Monday, 7th April 2025 9:52:06 am
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2024 Nousmedis, CeGe
 * ------------------------------------
 */


import { inject, Injectable } from '@angular/core';
import {
  ResolveFn
} from '@angular/router';
import { FascicleService } from '../services/fascicle.service';

export const FascicleEditResolver: ResolveFn<any> = async (route, state) => {

  const idCatalog = route.paramMap.get('idCatalog');
  const id = route.paramMap.get('id');

  const fascicleService = inject(FascicleService);

  try {
    const breadcrumbs = await fascicleService.getBreadCrumbFascicleEdit(idCatalog, id);
     // Verificar datos
    return breadcrumbs;
  } catch (error) {
    console.error('Error en el Resolver:', error);
    return []; // Manejo de errores: devuelve un array vacío o un valor por defecto
  }
};